import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  wide?: boolean;
}
export function Modal({
  open,
  onClose,
  title,
  children,
  wide
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-1069" data-mp="3qlr699ixgrx3">
      {open && <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4" data-id="element-1070" data-mp="3qkpjw8wgoj02">
          <motion.div className="absolute inset-0 bg-black/75" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: 'easeOut'
      }} onClick={onClose} data-id="element-1071" data-mp="2k682d9xvo72r" />
          <motion.div role="dialog" aria-modal="true" aria-label={title} className={`relative max-h-[92vh] w-full overflow-y-auto rounded-t-2xl border border-line bg-surface sm:rounded-2xl ${wide ? 'sm:max-w-3xl' : 'sm:max-w-lg'}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-1072" data-mp="2n1r2k2j9saxq">
            <div className="sticky top-0 z-10 flex items-center justify-between border-b border-line bg-surface px-5 py-4" data-id="element-1073" data-mp="1pgl88uw5r121">
              <h2 className="font-display text-base font-bold" data-id="element-1074" data-mp="1ubs7nqie9jl5">{title}</h2>
              <button onClick={onClose} className="rounded-lg p-1.5 text-mist hover:bg-white/5 hover:text-white" aria-label="Cerrar" data-id="element-1075" data-mp="1gf5bhpy9mxga">
                <XIcon className="h-5 w-5" data-id="element-1076" data-mp="3n2m57v1jenjg" />
              </button>
            </div>
            <div className="p-5" data-id="element-1077" data-mp="3n4fe7gzmhjum">{children}</div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}